import { render, staticRenderFns } from "./RegisterConfirmation.vue?vue&type=template&id=3dad8f7e&scoped=true&"
import script from "./RegisterConfirmation.vue?vue&type=script&lang=ts&"
export * from "./RegisterConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterConfirmation.vue?vue&type=style&index=0&id=3dad8f7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dad8f7e",
  null
  
)

export default component.exports